import React, { type ReactElement, useEffect, useState } from 'react'
import CustomTabs from 'features/ui/custom-tabs'
import { type CustomTab } from 'common/utils/types'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'store/hooks'
import { type ListAIVendor, type ListVendor } from 'features/vendors/vendorList.types'
import { getRejectedVendors, getVerifiedVendors } from 'features/vendors/vendorList.service'
import { resetState, setRejectedSearch, setVerifiedSearch } from 'features/vendors/vendorList.slice'

import WelcomeHeader from '../../ui/welcome-header/WelcomeHeader'

import RejectionReasonDialog from './rejction-reason-dialog/RejectionReasonDialog'
import styles from './VendorListContainer.module.scss'
import VendorList from './vendor-list'
import AIVerification from './ai-verification'

const VendorListContainer: React.FC = (): ReactElement => {
  const navigate = useNavigate()
  const [rejectedVendor, setRejectedVendor] = useState<ListVendor | ListAIVendor | null>(null)

  const openVendorProfile = (vendor: ListVendor | ListAIVendor): void => {
    navigate(`/vendor/${vendor.id}`)
  }

  const showReasonPopup = (vendor: ListVendor | ListAIVendor): void => {
    setRejectedVendor(vendor)
  }

  const handleCloseVendorDialog = (): void => {
    setRejectedVendor(null)
  }

  const tabElements: CustomTab[] = [
    {
      title: 'Verifikovani',
      content: (
        <VendorList
          listName="verifiedVendorList"
          countName="verifiedCount"
          statusName="getVerifiedVendorListStatus"
          searchName="verifiedSearch"
          pageName="verifiedPage"
          loadPageAction={getVerifiedVendors}
          setSearchAction={setVerifiedSearch}
          actionButtonText="Vidi profil"
          actionButtonHandler={openVendorProfile}
        />
      ),
    },
    {
      title: 'Odbijeni',
      content: (
        <VendorList
          listName="rejectedVendorList"
          countName="rejectedCount"
          statusName="getRejectedVendorListStatus"
          searchName="rejectedSearch"
          pageName="rejectedPage"
          loadPageAction={getRejectedVendors}
          setSearchAction={setRejectedSearch}
          actionButtonText="Vidi razlog odbijanja"
          actionButtonHandler={showReasonPopup}
        />
      ),
    },
    {
      title: 'AI verifikacija',
      content: <AIVerification openVendorProfile={openVendorProfile} showReasonPopup={showReasonPopup} />,
    },
  ]

  const dispatch = useAppDispatch()

  useEffect(() => {
    return () => {
      dispatch(resetState())
    }
  }, [])

  return (
    <div className={styles.container}>
      <WelcomeHeader
        title={'Dobrodošli na stranicu SVI VENDORI.'}
        subtitle={'Ovde možete videti listu svih vendora.'}
      />
      <div className={styles.tabContainer}>
        <CustomTabs tabs={tabElements}></CustomTabs>
      </div>
      {rejectedVendor && (
        <RejectionReasonDialog
          vendor={rejectedVendor}
          onClose={handleCloseVendorDialog}
          open={!!rejectedVendor}
          confirmButtonAction={() => {
            handleCloseVendorDialog()
          }}
        />
      )}
    </div>
  )
}

export default VendorListContainer
